import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Box, FormControl, InputLabel } from '@mui/material';
import Select from 'react-select';
import { getUsers } from '../../../services/UserService';
import { Select as MUISelect, MenuItem } from '@mui/material';
import {
  ROLE_LABEL,
  ROLE_OPTION_MANAGER,
  ROLE_OPTION_NON_MANAGER,
} from '../ProjectConstants';
import '../../../pages/People/PeopleComponent.css';

const AddResourceComponent = forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [users, setUsers] = React.useState([]);
  const [name, setName] = useState();
  const [id, setId] = useState();
  const [role, setRole] = useState('Team Member');
  const [selected, setSelected] = useState('');
  const [isLastActionFocus, setIsLastActionFocus] = useState(false);

  useImperativeHandle(ref, () => {
    return { id: id, name: name, role: role };
  });

  const { currentProjectEmployees } = props;

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  const getNames = async (name) => {
    setIsLoading(true);
    const userList = await getUsers(name);
    setUsers((prev) => []);
    if (userList.data.content) {
      userList.data.content
        .filter(
          (user) =>
            user.status === 'ACTIVE' &&
            currentProjectEmployees
              .filter((item) => item?.id)
              .findIndex(
                (employeee) =>
                  (employeee.id ? employeee.id : employeee.id) === user.id,
              ) === -1,
        )
        .forEach((user) => {
          const usersToSet = {
            value: user.id,
            label: user.firstName + ' ' + user.lastName + ' (' + user.employeeCode + ')',
          };
          setUsers((prev) => [...prev, usersToSet]);
        });
      setIsLoading(false);
    }
  };
  const handleChange = (event) => {
    setRole(event.target.value);
  };

  const optimizedFn = React.useCallback(debounce(getNames), []);

  return (
    <Box style={{ display: 'flex' }}>
      <Box style={{ width: '60%', marginLeft: '0px' }} className="search-bar">
        <Select
          blurInputOnSelect={true}
          maxMenuHeight={125}
          className="search-select"
          placeholder="Please select the employee name..."
          name="empName"
          isLoading={isLoading}
          isSearchable={true}
          options={users}
          onInputChange={(e) => {
            if (e !== '') {
              setIsLastActionFocus(false);
              optimizedFn(e);
              setSelected(e);
            } else {
              setUsers(() => []);
            }
          }}
          onFocus={() => {
            setIsLastActionFocus(true);
          }}
          onBlur={() => {
            setIsLastActionFocus(false);
          }}
          value={isLastActionFocus ? '' : selected}
          onChange={(choice) => {
            setSelected(choice);
            setName(choice.label);
            setId(choice.value);
          }}
        />
      </Box>
      <Box style={{ width: '20%', marginLeft: '10%' }}>
        <FormControl size="small" fullWidth>
          <InputLabel id="role-select-label">{ROLE_LABEL}</InputLabel>
          <MUISelect
            labelId="role-select-label"
            label="Role"
            value={role ? role : 'Team Member'}
            onChange={(e) => handleChange(e)}
          >
            <MenuItem value={ROLE_OPTION_NON_MANAGER}>
              {ROLE_OPTION_NON_MANAGER}
            </MenuItem>
            <MenuItem value={ROLE_OPTION_MANAGER}>
              {ROLE_OPTION_MANAGER}
            </MenuItem>
          </MUISelect>
        </FormControl>
      </Box>
    </Box>
  );
});

export default AddResourceComponent;
